import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ProdIssIndexActions, { ProdIssIndexTypes } from '../Stores/ProdIssIndex/Actions';

const getAppStore = state => state.app;

export function* prodIssIndexFetchProdIssIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(ProdIssIndexActions.prodIssIndexFetchProdIssIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `prodIss/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        ProdIssIndexActions.prodIssIndexFetchProdIssIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdIssIndexActions.prodIssIndexFetchProdIssIndexLoading(false));
  }
}

export function* prodIssIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodIssDetail/update/${hdrId}`));
}

export function* prodIssIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PROD_ISS/${hdrId}/ProdIssHdr`));
}

export function* prodIssIndexResetProdIssFServ01({ hdrIds }) {
  try {
    yield put(ProdIssIndexActions.prodIssIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `prodIss/fServProcess/RESET_PROD_ISS_F_SERV_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(ProdIssIndexActions.prodIssIndexResetProdIssFServ01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdIssIndexActions.prodIssIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(ProdIssIndexTypes.PROD_ISS_INDEX_FETCH_PROD_ISS_INDEX, prodIssIndexFetchProdIssIndex),
  takeLatest(ProdIssIndexTypes.PROD_ISS_INDEX_GO_TO_DOCUMENT, prodIssIndexGoToDocument),
  takeLatest(ProdIssIndexTypes.PROD_ISS_INDEX_GO_TO_AUDIT, prodIssIndexGoToAudit),
  takeLatest(
    ProdIssIndexTypes.PROD_ISS_INDEX_RESET_PROD_ISS_F_SERV01,
    prodIssIndexResetProdIssFServ01
  )
];
